import type { ReactNode } from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { informationsRucService } from "services";
import { useSnackbarErrorHandler } from "utils/errorHandling";

interface UseInformationsRucUploadReturn {
  uploadNewRucFile: () => void;
  isLoading: boolean;
  FileInput: () => ReactNode;
}

export function useInformationsRucUpload(): UseInformationsRucUploadReturn {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileFormData, setFileFormData] = useState<FormData | null>(null);
  const { catchErrors, isLoading } = useSnackbarErrorHandler({
    dontThrow: true,
    defaultIsLoading: false,
  });

  useEffect(() => {
    if (fileFormData != null) {
      void catchErrors(async () => {
        await informationsRucService.uploadNewRucExcel(fileFormData);
      });
    }
  }, [catchErrors, fileFormData]);

  const uploadNewRucFile = useCallback((): void => {
    if (fileInputRef.current != null) {
      fileInputRef.current.click();
    }
  }, [fileInputRef]);

  const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0];
    // ES-Lint est un teubé, en appliquant cela il râle lors du .append()
    // et du coup, il faudrait le ! mais il va râler aussi...
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (file != null && file.name.endsWith(".xlsx")) {
      const formData = new FormData();
      formData.append("file", file);
      setFileFormData(formData);
    } else {
      setFileFormData(null);
    }
  }, []);

  return {
    uploadNewRucFile,
    isLoading,
    // Ce composant caché est nécessaire pour déclencher la sélection de fichier
    FileInput: () => (
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".xlsx"
        style={{ display: "none" }}
      />
    ),
  };
}
